<template>
<div class="aqi-hourly-chart">
  <div>
    <e-chart ref="chart" />
  </div>
  <ul class="aqi-hourly-chart-legend">
    <li v-for="(n, index) in data[factorId]" :key="index" class="legend-item">
      <section>{{n}}</section>
      <label></label>
    </li>
  </ul>
</div>
</template>

<script>
import EChart from '../../../../components/Charts/ECharts'

export default {
  name: 'AqiHourlyChart',
  components: {EChart},
  props: {
    data: {
      required: true,
      type: Object
    },
    factorId: {
      required: true,
      type: String
    }
  },
  methods: {
    renderChart () {
      const {data, factorId} = this
      const {name, days} = data
      const chartOpt = {
        title: {
          text: name,
          left: 'center',
          textStyle: {
            color: '#cccccc'
          }
        },
        grid: {
          top: 30,
          right: 20,
          bottom: 10,
          left: 20,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: (() => {
            const hours = []

            for (let i = 0; i < 24; i++) {
              hours.push(i.toString().padStart(2, '0'))
            }

            return hours
          })(),
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#ccc'
            },
            interval: 0
          },
          axisTick: {
            show: false,
            alignWithLabel: false
          },
          axisLabel: {
            fontSize: 10,
            color: '#606266'
          },
          z: 999
        },
        yAxis: {
          type: 'category',
          data: days.map(day => day.value.toString().padStart(2, '0')),
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#ccc'
            },
            interval: 0
          },
          axisTick: {
            show: false,
            alignWithLabel: false
          },
          axisLabel: {
            fontSize: 10,
            color: '#606266'
          },
          z: 999
        },
        visualMap: {
          show: false,
          left: 'center',
          bottom: 10,
          orient: 'horizontal',
          pieces: [{
            gte: 0,
            lte: 50,
            color: 'rgb(0,228,0)'
          }, {
            gt: 50,
            lte: 100,
            color: 'rgb(255,255,0)'
          }, {
            gt: 100,
            lte: 150,
            color: 'rgb(255,126,0)'
          }, {
            gt: 150,
            lte: 200,
            color: 'rgb(255,0,0)'
          }, {
            gt: 200,
            lte: 300,
            color: 'rgb(153,0,76)'
          }, {
            gt: 300,
            color: 'rgb(126,0,35)'
          }],
          outOfRange: {
            color: '#999'
          },
          itemGap: 5,
          itemWidth: 16,
          itemHeight: 10,
          textGap: 3,
          textStyle: {
            fontSize: 10
          }
        },
        series: [{
          name,
          type: 'heatmap',
          data: days.reduce((list, day, yIndex) => day.hours.reduce((list, data, xIndex) => {
            const {iaqi} = data[factorId]
            list.push([xIndex, yIndex, Number.isFinite(iaqi) ? Number(iaqi.toFixed(2)) : null])
            return list
          }, list), []),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }],
        tooltip: {
          appendToBody: true
        }
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  },
  watch: {
    data () {
      this.renderChart()
    },
    factorId () {
      this.renderChart()
    }
  },
  mounted () {
    setTimeout(() => {
      this.renderChart()
    }, 0)
  }
}
</script>

<style lang="scss" scoped>
.aqi-hourly-chart {
  display: grid;
  grid-template-rows: auto 50px;
  width: 250px;
  height: 320px;

  .aqi-hourly-chart-legend {
    display: grid;
    grid-template-columns: repeat(3, max-content);
    grid-column-gap: 10px;
    justify-content: center;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .legend-item {
    --section-size: 16px;

    font-size: 12px;
    display: grid;
    grid-template-columns: var(--section-size) max-content;
    grid-column-gap: 5px;
    align-items: center;
    height: var(--section-size);
    line-height: var(--section-size);

    > section {
      height: 100%;
      border-radius: var(--section-size);
      color: #ffffff;
      text-align: center;
    }

    > label {
      color: #303133;
    }

    &:nth-child(1) {
      > section {
        background-color: rgb(0, 228, 0);
      }

      > label {
        &:before {
          content: "优"
        }
      }
    }

    &:nth-child(2) {
      > section {
        color: #606266;
        background-color: rgb(255, 255, 0);
      }

      > label {
        &:before {
          content: "良"
        }
      }
    }

    &:nth-child(3) {
      > section {
        background-color: rgb(255, 126, 0);
      }

      > label {
        &:before {
          content: "轻度"
        }
      }
    }

    &:nth-child(4) {
      > section {
        background-color: rgb(255, 0, 0);
      }

      > label {
        &:before {
          content: "中度"
        }
      }
    }

    &:nth-child(5) {
      > section {
        background-color: rgb(153, 0, 76);
      }

      > label {
        &:before {
          content: "重度"
        }
      }
    }

    &:nth-child(6) {
      > section {
        background-color: rgb(126, 0, 35);
      }

      > label {
        &:before {
          content: "严重"
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/09PollutionFeature/AqiHourlyChart.vue